import React, { useState, useEffect, useCallback } from "react";
import { withRouter, useHistory, useParams } from "react-router-dom";
import bigInt from "big-integer";
import moment from "moment";

import { withStyles } from "@material-ui/core/styles";
import MuiAlert from "@material-ui/lab/Alert";
import { Fade, Snackbar } from "@material-ui/core";

import { withNamespaces } from "react-i18next";

import PoolMainInfoCard from "./components/mainInfoCard";
import DescriptionCard from "./components/descriptionCard";
import InvestmentCard from "./components/investCard";
import DisclaimerCard from "./components/disclaimerCard";
import AuditCard from "./components/auditCard";
import ManageCard from "./components/manageCard";

import BuyModal from "./components/modal";
import VoteModal from "../voting/components/voteModal";
import RegionBanModal from "./components/regionBanModal";

import { useAccount } from "../../contexts/AccountContext";

import {
  ALLOW_CLAIM_RETURNED,
  CANCEL_PRESALE_RETURNED,
  COLLECT_FUND_RETURNED,
  ERROR,
  GET_REFUND_RETURNED,
  INVEST_RETURNED,
  LOCK_LIQUIDITY_RETURNED,
  PUBLIC_CLAIM_RETURNED,
  SEND_UNSOLD_TOKENS_RETURNED,
  THEME_CHANGE_RETURNED,
  VOTE_RETURNED,
  tokens,
} from "../../constants";

import Store from "../../stores/store";

import {
  PUBLIC_CLAIM,
  CONNECTION_CONNECTED,
  GET_PUBLIC_PRESALE_INFO,
  GET_PUBLIC_PRESALE_INFO_RETURNED,
  PUBLIC_INVEST,
  LOCK_LIQUIDITY,
  VOTE,
  COLLECT_FUND,
  CANCEL_PRESALE,
  SEND_UNSOLD_TOKENS,
  ALLOW_CLAIM,
  GET_REFUND,
  toFixed,
  _getBanned,
} from "../../constants/constants";
import InfoRightCards from "./components/infoRightCards";
import Spinner from "../stake/components/Spinner";
import { _signMessage } from "../../stores/private";
import ConfirmationModal from "../confirmationModal";

const emitter = Store.emitter;
const dispatcher = Store.dispatcher;
const store = Store.store;

const styles = (theme) => ({
  root: {
    flex: 1,
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    padding: "30px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      padding: "70px",
    },
    fontFamily: "Poppins",
    position: "relative",
  },
  mainContainer: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "1140px",
    padding: "8px 0px 30px",
  },
  warningContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    height: "50px",
    padding: "10px 20px",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    borderRadius: "12px",
  },
  descriptionContainer: {
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
  },
  showInfoMobile: {
    width: "100%",
    display: "block",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  showInfoDesktop: {
    display: "none",
    width: "50%",
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  warningText: {
    color: theme?.colors?.poolCard?.title,
    textAlign: "center",
    fontSize: "20px",
    lineHeight: "25px",
  },
  goBackContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "auto",

    marginBottom: "16px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "24px",
    },
  },
  goBackIcon: {
    stroke: theme?.colors?.presale?.cardTitle,
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
  goBackBtn: {
    color: theme?.colors?.presale?.cardTitle,
    backgroundColor: "transparent",
    border: "none",
    fontWeight: "600",
    fontSize: "18px",
    cursor: "pointer",

    [theme.breakpoints.up("sm")]: {
      fontSize: "22px",
    },
  },
  presaleContainer: {
    display: "flex",
    width: "100%",
    gap: "40px",

    [theme.breakpoints.up("sm")]: {
      gap: "80px",
    },
  },
  loader: {
    width: "100%",
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "62px",
  },
  loadingIcon: {
    zIndex: 5,
    color: theme?.colors?.presale?.loadingIcon,
    position: "absolute",
    top: "100px",
    left: "50%",
  },
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const PresalePage = ({ classes, location }) => {
  const history = useHistory();
  const { bscsId } = useParams();
  const [isBannedLocation, setBannedLocation] = useState(false);
  const [whitelisted, setWhitelisted] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [poolInfo, setPoolInfo] = useState(
    (store.getStore("publicPresales") &&
      store.getStore("publicPresales")[bscsId]) ||
      {}
  );

  const [openBuyModal, showBuyModal] = useState(false);
  const [openVoteModal, showVoteModal] = useState(false);

  const [showTxLoadingModal, setShowTxLoadingModal] = useState(false);
  const [showTxSuccessModal, setShowTxSuccessModal] = useState(false);

  const [openBannedModal, showBannedModal] = useState(false);
  const { account } = useAccount();

  const fetchBanned = async () => {
    const _isBanned = await _getBanned();
    setBannedLocation(_isBanned);
  };

  const themeChanged = useCallback(() => {
    history.push("/");
  }, [history]);

  const connectionConnected = useCallback(() => {
    dispatcher.dispatch({
      type: GET_PUBLIC_PRESALE_INFO,
      content: { presaleIndex: bscsId },
    });
  }, [bscsId]);

  const getPresaleInfoReturned = useCallback(() => {
    setPoolInfo(store.getStore("publicPresales")[bscsId]);
  }, [bscsId]);

  useEffect(() => {
    dispatcher.dispatch({
      type: GET_PUBLIC_PRESALE_INFO,
      content: { presaleIndex: bscsId },
    });

    const getPublicPresaleInfoTimeoutId = setInterval(() => {
      dispatcher.dispatch({
        type: GET_PUBLIC_PRESALE_INFO,
        content: { presaleIndex: bscsId },
      });
    }, 5000);

    return () => {
      clearInterval(getPublicPresaleInfoTimeoutId);
    };
  }, [bscsId]);

  useEffect(() => {
    emitter.on(CONNECTION_CONNECTED, () => {
      connectionConnected();
    });

    emitter.on(GET_PUBLIC_PRESALE_INFO_RETURNED, () => {
      getPresaleInfoReturned();
    });
    emitter.on(THEME_CHANGE_RETURNED, () => {
      themeChanged();
    });

    fetchBanned();
    return () => {
      emitter.removeListener(CONNECTION_CONNECTED, () => {
        connectionConnected();
      });

      emitter.removeListener(GET_PUBLIC_PRESALE_INFO_RETURNED, () => {
        getPresaleInfoReturned();
      });
      emitter.removeListener(THEME_CHANGE_RETURNED, () => {
        themeChanged();
      });
    };
  }, [bscsId, connectionConnected, getPresaleInfoReturned, themeChanged]);

  useEffect(() => {
    emitter.on(PUBLIC_CLAIM_RETURNED, txReturned);
    emitter.on(VOTE_RETURNED, txReturned);
    emitter.on(COLLECT_FUND_RETURNED, txReturned);
    emitter.on(CANCEL_PRESALE_RETURNED, txReturned);
    emitter.on(SEND_UNSOLD_TOKENS_RETURNED, txReturned);
    emitter.on(ALLOW_CLAIM_RETURNED, txReturned);
    emitter.on(GET_REFUND_RETURNED, txReturned);
    emitter.on(LOCK_LIQUIDITY_RETURNED, txReturned);
    emitter.on(INVEST_RETURNED, txReturned);

    emitter.on(ERROR, errorReturned);

    return () => {
      emitter.removeListener(PUBLIC_CLAIM_RETURNED, txReturned);
      emitter.removeListener(VOTE_RETURNED, txReturned);
      emitter.removeListener(COLLECT_FUND_RETURNED, txReturned);
      emitter.removeListener(CANCEL_PRESALE_RETURNED, txReturned);
      emitter.removeListener(SEND_UNSOLD_TOKENS_RETURNED, txReturned);
      emitter.removeListener(ALLOW_CLAIM_RETURNED, txReturned);
      emitter.removeListener(INVEST_RETURNED, txReturned);
      emitter.removeListener(GET_REFUND_RETURNED, txReturned);
      emitter.removeListener(LOCK_LIQUIDITY_RETURNED, txReturned);

      emitter.removeListener(ERROR, errorReturned);
    };
  }, []);

  const errorReturned = () => {
    setShowTxLoadingModal(false);
    setShowTxSuccessModal(false);
  };

  const txReturned = () => {
    setShowTxSuccessModal(true);
  };

  const onClaim = () => {
    setShowTxLoadingModal(true);
    dispatcher.dispatch({
      type: PUBLIC_CLAIM,
      content: {
        presaleIndex: bscsId,
      },
    });
  };

  const onVoteClicked = () => {
    showVoteModal(true);
  };

  const onVote = (type) => {
    setShowTxLoadingModal(true);
    dispatcher.dispatch({
      type: VOTE,
      content: {
        presaleIndex: bscsId,
        voteType: type,
      },
    });
  };

  const onCollect = () => {
    setShowTxLoadingModal(true);
    dispatcher.dispatch({
      type: COLLECT_FUND,
      content: {
        presaleIndex: bscsId,
      },
    });
  };

  const onCancelPresale = () => {
    setShowTxLoadingModal(true);
    dispatcher.dispatch({
      type: CANCEL_PRESALE,
      content: {
        presaleIndex: bscsId,
      },
    });
  };

  const onSendUnsoldTokens = () => {
    setShowTxLoadingModal(true);
    dispatcher.dispatch({
      type: SEND_UNSOLD_TOKENS,
      content: {
        presaleIndex: bscsId,
      },
    });
  };

  const onAllowClaim = () => {
    setShowTxLoadingModal(true);
    dispatcher.dispatch({
      type: ALLOW_CLAIM,
      content: {
        presaleIndex: bscsId,
      },
    });
  };

  const onGetRefund = () => {
    setShowTxLoadingModal(true);
    dispatcher.dispatch({
      type: GET_REFUND,
      content: {
        presaleIndex: bscsId,
      },
    });
  };

  const onInvest = () => {
    const isWhitelisted = poolInfo?.isWhitelistedAddress;
    if (!isWhitelisted) {
      setErrorMessage("You are not whitelisted...");
      return;
    }
    if (poolInfo?.isBanned && isBannedLocation) {
      showBannedModal(poolInfo?.isBanned);
    } else {
      const isExpired = moment.unix(poolInfo?.closeTime).isBefore(moment.now());
      if (!isExpired) {
        showBuyModal(true);
      } else {
        setErrorMessage("Sale Expired...");
      }
    }
  };

  const onLockLiq = () => {
    const isExpired = moment
      .unix(poolInfo?.cakeLiquidityAddingTime)
      .isBefore(moment.now());
    const totalCollected = parseFloat(
      toFixed(
        bigInt(poolInfo?.totalCollectedWei || "0"),
        poolInfo?.fundingTokenDecimals || 18,
        6
      )
    );
    const hardCapWei = parseFloat(
      toFixed(
        bigInt(poolInfo?.hardCapInWei || "0"),
        poolInfo?.fundingTokenDecimals || 18,
        6
      )
    );
    if (totalCollected >= hardCapWei || isExpired) {
      setShowTxLoadingModal(true);
      dispatcher.dispatch({
        type: LOCK_LIQUIDITY,
        content: {
          presaleIndex: bscsId,
        },
      });
    } else {
      if (totalCollected < hardCapWei) {
        setErrorMessage("Cannot Lock Yet - Not HardCap Reached yet.");
      }
      if (!isExpired) {
        setErrorMessage("Cannot Lock Yet - Not locking time yet.");
      }
    }
  };

  const onBuy = async (inputAmount) => {
    const message = `I hereby declare, through my signature, my proficiency in financial matters and intent to partake in digital asset transactions, despite their volatility and high risks. I waive any right to hold this platform, its development team, or any affiliated organizations responsible for the results of my engagement in any token sale activities.`;
    const [signature, v, r, s] = await _signMessage(store, account, message);

    if (signature) {
      setShowTxLoadingModal(true);
      dispatcher.dispatch({
        type: PUBLIC_INVEST,
        content: {
          presaleIndex: bscsId,
          amount: inputAmount,
          decimals: poolInfo?.fundingTokenDecimals || 18,
          disclaimer: message,
          v,
          r,
          s,
        },
      });
    }
  };

  return (
    <div className={classes.root}>
      {errorMessage && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={true}
          autoHideDuration={3000}
          onClick={() => {
            setErrorMessage(false);
          }}
          onClose={() => {
            setErrorMessage(false);
          }}
        >
          <Alert severity="error">{errorMessage}</Alert>
        </Snackbar>
      )}
      {whitelisted &&
        poolInfo?.isWhitelistMode &&
        poolInfo?.isWhitelistedAddress &&
        poolInfo?.cakeLiquidityAddingTime && (
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={true}
            onClick={() => {
              setWhitelisted(false);
            }}
            onClose={() => {
              setWhitelisted(false);
            }}
          >
            <Alert severity={"info"}>
              {poolInfo?.isWhitelistMode &&
                poolInfo?.isWhitelistedAddress &&
                "Congrats, you are on the whitelist for this presale. Good luck!"}
            </Alert>
          </Snackbar>
        )}
      <Fade in={true} timeout={{ enter: 1000 }}>
        <div className={classes.mainContainer}>
          {!poolInfo?.saleTitle ||
          !poolInfo?.openTime ||
          !poolInfo?.linkImgMain ||
          !poolInfo?.presaleAddress ||
          !poolInfo?.totalStakedLocked ? (
            <div className={classes.loader}>
              <Spinner strokeSize="5px" width="60px" height="60px" />
            </div>
          ) : (
            <>
              <div className={classes.goBackContainer}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  className={classes.goBackIcon}
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.75 19.5 8.25 12l7.5-7.5"
                  />
                </svg>

                <button
                  className={classes.goBackBtn}
                  type="button"
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  Go back
                </button>
              </div>

              <div className={classes.presaleContainer}>
                <div className={classes.descriptionContainer}>
                  <PoolMainInfoCard poolInfo={poolInfo} />
                  <DescriptionCard poolInfo={poolInfo} />
                  {account &&
                    poolInfo?.presaleCreatorAddress === account.address && (
                      <ManageCard
                        poolInfo={poolInfo}
                        onCollect={onCollect}
                        onCancelPresale={onCancelPresale}
                        onSendUnsoldTokens={onSendUnsoldTokens}
                        onAllowClaim={onAllowClaim}
                        onLockLiq={onLockLiq}
                      />
                    )}

                  <div className={classes.showInfoMobile}>
                    <InfoRightCards poolInfo={poolInfo} />
                    <DisclaimerCard poolInfo={poolInfo} />
                  </div>

                  <InvestmentCard
                    poolInfo={poolInfo}
                    onClaim={onClaim}
                    onVote={onVoteClicked}
                    onRefund={onGetRefund}
                    onBuy={onInvest}
                    account={account}
                  />

                  <AuditCard poolInfo={poolInfo} />

                  <BuyModal
                    closeModal={() => {
                      showBuyModal(false);
                    }}
                    modalOpen={openBuyModal}
                    tokenPrice={parseFloat(
                      toFixed(
                        bigInt(poolInfo?.tokenPriceInWei),
                        poolInfo?.fundingTokenDecimals || 18,
                        6
                      )
                    )}
                    minInvestAmount={parseFloat(
                      toFixed(
                        bigInt(poolInfo?.minInvestInWei),
                        poolInfo?.fundingTokenDecimals || 18,
                        6
                      )
                    )}
                    maxInvestAmount={parseFloat(
                      toFixed(
                        bigInt(poolInfo?.maxInvestInWei),
                        poolInfo?.fundingTokenDecimals || 18,
                        6
                      )
                    )}
                    presale={poolInfo}
                    stakedLockedAmount={poolInfo?.voteAvailable}
                    totalLockedValues={poolInfo?.totalStakedLocked}
                    fundingToken={tokens[poolInfo?.fundingTokenAddress]}
                    fundingTokenBalance={poolInfo?.fundingTokenBalance}
                    onBuy={onBuy}
                  />
                  <VoteModal
                    closeModal={() => {
                      showVoteModal(false);
                    }}
                    modalOpen={openVoteModal}
                    salesTitle={poolInfo?.saleTitle || ""}
                    onVote={onVote}
                  />

                  <ConfirmationModal
                    modalOpen={showTxLoadingModal}
                    onClose={() => {
                      setShowTxLoadingModal(false);
                      setShowTxSuccessModal(false);
                    }}
                    showSuccessModal={showTxSuccessModal}
                  />
                  <RegionBanModal
                    modalOpen={openBannedModal}
                    closeModal={() => {
                      showBannedModal(false);
                    }}
                  />
                </div>
                <div className={classes.showInfoDesktop}>
                  <InfoRightCards poolInfo={poolInfo} />
                  <DisclaimerCard poolInfo={poolInfo} />
                </div>
              </div>
            </>
          )}
        </div>
      </Fade>
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(PresalePage)));
